module.exports = __webpack_public_path__ + "static/media/banner.e5f42211.png";